import type { Project } from '../types';
import { createPopoverStore } from './createPopoverStore';

export interface ProjectTooltipState {
  project: Project;
  anchorRect: DOMRect;
}

const store = createPopoverStore<ProjectTooltipState>({ hideDelay: 120 });

export const projectTooltipState = store.state;

export function showProjectTooltip(project: Project, anchorEl: HTMLElement) {
  store.show({ project, anchorRect: anchorEl.getBoundingClientRect() });
}

export function hideProjectTooltip(immediate = false) {
  store.hide(immediate);
}

export function cancelHideProjectTooltip() {
  store.cancelHide();
}
